'use client'

import { useReadContract } from 'wagmi'
import { Card, CardContent, CardHeader, CardTitle } from './ui/card'
import { Badge } from './ui/badge'
import { MULTISTAKING_ABI } from '../lib/contracts'

export function ContractOwner() {
  const contractAddress = process.env.NEXT_PUBLIC_CONTRACT_ADDRESS as `0x${string}`
  
  const { data: owner, isLoading, error } = useReadContract({
    address: contractAddress,
    abi: MULTISTAKING_ABI,
    functionName: 'owner',
  })

  const formatAddress = (address: string) => {
    return `${address.slice(0, 6)}...${address.slice(-4)}`
  }

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text)
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          Contract Owner
          <Badge variant="outline">Admin</Badge>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading && (
          <div className="text-sm text-muted-foreground">Loading owner...</div>
        )}
        
        {error && (
          <div className="text-sm text-red-500">
            Error: {error.message}
          </div>
        )}
        
        {owner && (
          <div className="space-y-2">
            <div className="text-sm text-muted-foreground">Owner Address:</div>
            <div 
              className="font-mono text-sm bg-muted p-2 rounded cursor-pointer hover:bg-muted/80 transition-colors"
              onClick={() => copyToClipboard(owner)}
              title="Click to copy full address"
            >
              <div className="block sm:hidden">{formatAddress(owner)}</div>
              <div className="hidden sm:block">{owner}</div>
            </div>
            <div className="text-xs text-muted-foreground">
              Click address to copy • Only the owner can create new pools
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  )
} 
